(function() {
    function waitForSwiper(callback) {
        if (typeof Swiper !== 'undefined') {
            callback();
        } else {
            setTimeout(function() {
                waitForSwiper(callback);
            }, 50);
        }
    }
    
    function initDiscountOffersSliders() {
        const sliders = document.querySelectorAll('[data-discount-offers-slider]');
        
        sliders.forEach(function(slider) {
            if (slider.swiper) {
                return; // Already initialized
            }
            
            const slides = slider.querySelectorAll('.swiper-slide');
            if (slides.length === 0) {
                return; // No slides to show
            }
            
            try {
                slider.swiper = new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    navigation: {
                        nextEl: slider.querySelector('.swiper-button-next'),
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 'auto',
                            spaceBetween: 12,
                        },
                        768: {
                            slidesPerView: 'auto',
                            spaceBetween: 16,
                        },
                        1024: {
                            slidesPerView: 'auto',
                            spaceBetween: 20,
                        }
                    }
                });
            } catch (e) {
                console.error('Error initializing discount offers slider:', e);
            }
        });
    }
    
    function initTrustBadgesSliders() {
        const sliders = document.querySelectorAll('[data-trust-badges-slider]');
        
        sliders.forEach(function(slider) {
            if (slider.swiper) {
                return; // Already initialized
            }
            
            const slides = slider.querySelectorAll('.swiper-slide');
            if (slides.length === 0) {
                return; // No slides to show
            }
            
            try {
                slider.swiper = new Swiper(slider, {
                    slidesPerView: 2.5,
                    spaceBetween: 12,
                    slidesPerGroup: 3,
                    autoplay: {
            delay: 1800, // 1 second autoplay
            disableOnInteraction: false,
        },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                            slidesPerGroup: 3,
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                            slidesPerGroup: 3,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 16,
                            slidesPerGroup: 3,
                        },
                        1024: {
                            slidesPerView: 2.5,
                            spaceBetween: 12,
                            slidesPerGroup: 3,
                        }
                    }
                });
            } catch (e) {
                console.error('Error initializing trust badges slider:', e);
            }
        });
    }
    
    function initCouponCodeCopy() {
        const copyableBadges = document.querySelectorAll('.discount-offer-card__badge--copyable');
        
        copyableBadges.forEach(function(badge) {
            // Remove existing listeners to avoid duplicates
            const newBadge = badge.cloneNode(true);
            badge.parentNode.replaceChild(newBadge, badge);
            
            newBadge.addEventListener('click', function() {
                copyCouponCode(newBadge);
            });
            
            newBadge.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    copyCouponCode(newBadge);
                }
            });
        });
    }
    
    function copyCouponCode(badge) {
        const couponCode = badge.getAttribute('data-coupon-code');
        
        if (!couponCode) {
            return;
        }
        
        // Copy to clipboard
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(couponCode).then(function() {
                showCopiedFeedback(badge);
            }).catch(function(err) {
                console.error('Failed to copy coupon code:', err);
                fallbackCopyToClipboard(couponCode, badge);
            });
        } else {
            fallbackCopyToClipboard(couponCode, badge);
        }
    }
    
    function fallbackCopyToClipboard(text, badge) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
            const successful = document.execCommand('copy');
            if (successful) {
                showCopiedFeedback(badge);
            }
        } catch (err) {
            console.error('Fallback copy failed:', err);
        }
        
        document.body.removeChild(textArea);
    }
    
    function showCopiedFeedback(badge) {
        badge.classList.add('copied');
        
        setTimeout(function() {
            badge.classList.remove('copied');
        }, 2000);
    }
    
    // Wait for DOM and Swiper to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            waitForSwiper(function() {
                initDiscountOffersSliders();
                initTrustBadgesSliders();
            });
            initCouponCodeCopy();
        });
    } else {
        waitForSwiper(function() {
            initDiscountOffersSliders();
            initTrustBadgesSliders();
        });
        initCouponCodeCopy();
    }
    
    // Re-initialize when Shopify theme editor loads sections
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(event) {
            waitForSwiper(function() {
                setTimeout(function() {
                    initDiscountOffersSliders();
                    initTrustBadgesSliders();
                }, 100);
            });
            setTimeout(initCouponCodeCopy, 100);
        });
    }
})();

